/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./splitButton.vue?vue&type=template&id=5ec8d840&scoped=true&"
import script from "./splitButton.vue?vue&type=script&lang=js&"
export * from "./splitButton.vue?vue&type=script&lang=js&"
import style0 from "./splitButton.vue?vue&type=style&index=0&id=5ec8d840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8d840",
  null
  
)

export default component.exports